/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function CourseRowItemVenue(props) {
	return <a href={props?.url}>{decodeEntities(props?.name)}</a>;
}

export default CourseRowItemVenue;
